import React from "react";
import OurMissionPageSection from "../../Sections/OurMissionPageSection/Content";
const OurMissionPage = () => {
  return <OurMissionPageSection />;
};

export default OurMissionPage;
